import { ReactElement } from 'react';
import {
    Block as HardRetrieveIcon,
    DirectionsCar as TrafficIcon,
    EmojiFlags as RacingIcon,
    FlightTakeoff as LongRangeIcon,
    Forest as ForestIcon,
    HomeWork as BandoIcon,
    LocationCity as UrbanIcon,
    NaturePeople as ParkIcon,
    People as PeopleIcon,
    Power as PowerLinesIcon,
    GpsOff as SignalIcon,
    Gavel as RestrictedIcon,
    BeachAccess as CoastalIcon,
    Waves as WaterIcon,
    Water as WaterBelowIcon,
    Pets as WildlifeIcon,
    Hardware as HardSurfaceIcon,
    Moving as GapsIcon,
} from '@mui/icons-material';

const categoryIcons: Record<string, ReactElement> = {
    long_range: <LongRangeIcon />,
    bando:      <BandoIcon />,
    urban:      <UrbanIcon />,
    racing:     <RacingIcon />,
    forest:     <ForestIcon />,
    park:       <ParkIcon />,
    coastal:    <CoastalIcon />,
    water:      <WaterIcon />,
    gaps:       <GapsIcon />,
};

const hazardIcons: Record<string, ReactElement> = {
    traffic:      <TrafficIcon />,
    people:       <PeopleIcon />,
    power_lines:  <PowerLinesIcon />,
    signal:       <SignalIcon />,
    restricted:   <RestrictedIcon />,
    hard_surface: <HardSurfaceIcon />,
    water_below:  <WaterBelowIcon />,
    wildlife:     <WildlifeIcon />,
    hard_retrieve: <HardRetrieveIcon />,
};

export const renderCategoryIcon = (shortname: string): ReactElement | null => {
    return categoryIcons[shortname] || null;
};

export const renderHazardIcon = (shortname: string): ReactElement | null => {
    return hazardIcons[shortname] || null;
};
